import { css } from 'styled-components';
import token from 'styled-token';
import { fontColorMixin } from '../fontColorMixin';

/** @class SpinnerMixin */
/** @method */
export var SpinnerMixin = function SpinnerMixin(props) {
  return token({
    duration: 'Spinner.animation.duration',
    easing: 'Spinner.animation.easing',
    iterations: 'Spinner.animation.iterations'
  }, function (_ref) {
    var _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 0.5 : _ref$duration,
      _ref$easing = _ref.easing,
      easing = _ref$easing === void 0 ? 'linear' : _ref$easing,
      _ref$iterations = _ref.iterations,
      iterations = _ref$iterations === void 0 ? 'infinite' : _ref$iterations;
    return css(["@keyframes spin{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}animation:spin ", "s ", " ", ";", ""], duration, easing, iterations, fontColorMixin(props));
  })(props);
};